import { Beruf } from '@/domain/mitarbeiter/features/rotationsplan/entities/Beruf';
import { Select } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/components/SelectV2';
import { useRotationsplanFeatureContext } from '@/domain/mitarbeiter/features/rotationsplan/features/shared/RotationsplanFeatureContext';
import { Body } from '@e2n/ui/v2';
import { faCheck, faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function BerufeSelect({
  handleChange,
  id,
  invalid = false,
  value,
}: {
  handleChange: (beruf: Beruf) => void;
  id?: string;
  invalid?: boolean;
  value: Beruf;
}) {
  const { t } = useTranslation();
  const {
    store: {
      data: { berufe },
    },
  } = useRotationsplanFeatureContext();

  return (
    <Select<Beruf>
      id={id}
      invalid={invalid}
      selectedOption={value}
      onChange={handleChange}
      drawerLabel={t(
        'domain.mitarbeiter.rotationsplan.rotationsplaene.createRotationsplan.fields.beruf.label',
      )}
      options={berufe}
      renderTriggerContent={(selectedBeruf) =>
        selectedBeruf ? (
          <div className="flex items-center gap-2">
            <FontAwesomeIcon
              className="size-2.5"
              color={selectedBeruf.getBorderColor()}
              icon={faCircle}
            />
            <Body className="whitespace-nowrap truncate">
              {selectedBeruf.name}
            </Body>
          </div>
        ) : (
          <div>{t('actions.auswaehlen')}</div>
        )
      }
      renderListItem={(beruf, selectedBeruf) => (
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-2">
            <div className="text-sm">
              <FontAwesomeIcon
                color={beruf.getBorderColor()}
                icon={faCircle}
                size="xs"
              />
            </div>
            <div className="whitespace-nowrap truncate text-sm font-normal">
              {beruf.name}
            </div>
          </div>
          {beruf.id === selectedBeruf?.id && (
            <FontAwesomeIcon className="text-primary-blue-600" icon={faCheck} />
          )}
        </div>
      )}
    />
  );
}
